import type { Quote, SourceMetadata } from '../../api/quoteExtractor';

export interface BrowserQuote extends Quote {
  id: string;
  editedText: string | null;
  starred: boolean;
}

export interface SubmissionEcho {
  kind: 'text' | 'file';
  title: string;
  wordCount: number;
}

export type SessionStatus = 'idle' | 'uploading' | 'processing' | 'ready' | 'error';

export interface Session {
  status: SessionStatus;
  submission: SubmissionEcho | null;
  quotes: BrowserQuote[];
  noQuotesReason: string | null;
  sourceMetadata: SourceMetadata | null;
  error: string | null;
}

export const initialSession: Session = {
  status: 'idle',
  submission: null,
  quotes: [],
  noQuotesReason: null,
  sourceMetadata: null,
  error: null,
};
